import {ContentEditableHtmlEditorPlugin} from '@frontapp/editor-html';

import {inlineAttachmentAllowedAttributes} from '../../../../../srcCommon/helpers/messageDraftHelpers';

/*
 * Plugin.
 */

export function createInlineAttachmentPlugin(): ContentEditableHtmlEditorPlugin {
  return {
    // Allow attributes for inline image attachments.
    addAllowedAttributes: inlineAttachmentAllowedAttributes,
  };
}
